import React from 'react';
import img1 from '../assets/churro1.jpeg';
import img2 from '../assets/churro2.jpeg';
import img3 from '../assets/churro3.jpeg';
import img4 from '../assets/churro4.jpeg';
import img5 from '../assets/Together2.jpeg';
import img6 from '../assets/churro6.jpeg';
import img7 from '../assets/encuerada.jpeg';
import img8 from '../assets/churro8.jpeg';
import img9 from '../assets/churro9.jpeg';
import img10 from '../assets/churro10.jpeg';
import './Gallery.css';

const galleryImages = [
  {
    url: img1,
    alt: 'Our signature churros',
    caption: 'Signature Churros'
  },
  {
    url: img2,
    alt: 'Freshly made treats',
    caption: 'Fresh & Crispy'
  },
  {
    url: img3,
    alt: 'Churros with toppings',
    caption: 'Sweet Toppings'
  },
  {
    url: img10,
    alt: 'Austin Texas vibes',
    caption: 'Austin Vibes'
  },
  {
    url: img5,
    alt: 'Churros ready to serve',
    caption: 'Ready to Enjoy'
  },
  {
    url: img6,
    alt: 'Our kitchen at work',
    caption: 'Made With Love'
  },
  {
    url: img7,
    alt: 'Special churro creations',
    caption: 'Chef\'s Special'
  },
  {
    url: img9,
    alt: 'Churros and empanadas spread',
    caption: 'The Full Spread'
  },
  {
    url: img8,
    alt: 'Catering events',
    caption: 'Catering & Events'
  },
  {
    url: img4,
    alt: 'Our delicious creations',
    caption: 'Handcrafted Daily'
  }
];

const Gallery = () => {
  return (
    <section id="gallery" className="gallery">
      <div className="gallery__container">
        <div className="gallery__header">
          <span className="gallery__label">Gallery</span>
          <h2 className="gallery__heading">
            A Feast for the <span>Eyes</span>
          </h2>
          <p className="gallery__subheading">
            Follow us on social media for daily photos and updates
          </p>
        </div>
        <div className="gallery__grid">
          {galleryImages.map((img, idx) => (
            <div key={idx} className={`gallery__item gallery__item--${idx + 1}`}>
              <img src={img.url} alt={img.alt} />
              <div className="gallery__overlay">
                <span className="gallery__caption">{img.caption}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
